import React from "react";
import { motion } from "framer-motion";
import { objectives } from "../../constants/siteContent";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const ObjectivesSection = () => {
  return (
    <section id="objectives" data-testid="objectives-section" className="py-24 md:py-28 bg-[#D1111A]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer} className="text-center mb-16 md:mb-[4.5rem]">
          <motion.p variants={fadeInUp} className="text-white/80 font-semibold tracking-[0.2em] uppercase mb-3">The Four Key Objectives</motion.p>
          <motion.h2 variants={fadeInUp} className="font-editorial text-4xl md:text-6xl text-white italic">Game Changers</motion.h2>
        </motion.div>

        <motion.div className="grid md:grid-cols-2 gap-6 md:gap-7" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          {objectives.map((objective, index) => (
            <motion.div key={objective.title} variants={fadeInUp} className="bg-white p-7 md:p-8 border-l-4 border-[#D1111A] hover:shadow-xl transition-shadow" data-testid={`objective-${index}`}>
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <span className="font-editorial text-5xl text-[#D1111A]/20 italic">{objective.number}</span>
                </div>
                <div className="flex-1">
                  <div className="w-14 h-14 bg-[#D1111A] rounded-full flex items-center justify-center mb-4">
                    <objective.icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-editorial text-2xl text-[#0A0A0A] mb-1.5">{objective.title}</h3>
                  <p className="text-[#D1111A] font-medium text-sm mb-3.5">{objective.subtitle}</p>
                  <p className="text-[#0A0A0A]/70 leading-relaxed">{objective.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};